import * as RestClient from '../../utils/rest-service';
import Constants from '../../config/constants';
import { withDefaultSort } from '../../utils/utility';

export const searchComponentByText = (text, page = 0) => {
  const pageSize = Constants.DATA_TABLE_PAGE_SIZE;
  const sorted = withDefaultSort([]);
  const filtered = text;
  const isPublic = null;
  const sectionId = null;
  return searchComponent(pageSize, page, sorted, filtered, isPublic, sectionId);
};

export const searchComponent = (pageSize, page, sorted, filtered, isPublic, sectionId) => {
  const sectionParams = sectionId === null ? { section_id__isnull: true } : { section_id: sectionId };
  return RestClient.request({
    method: 'get',
    url: Constants.API_COMPONENT,
    params: {
      search: filtered,
      limit: pageSize,
      offset: pageSize * page,
      ordering: sorted
        ? sorted.map(sort => sort.desc ? `-${sort.id}` : sort.id ).join(',')
        : null,
      is_public: isPublic,
      ...sectionParams,
    },
  }).catch(err => Promise.reject(err.response.data));
};



// WEBPACK FOOTER //
// ./src/redux/component/component_actions.js